import { Controller } from '@hotwired/stimulus'

import { withSummaryItems } from '../src/mixins/with_summary_items'

// Connects to data-controller="update-summary-item"
export default class extends Controller {
  static values = {
    identifier: String,
    value: String
  }

  connect () {
    withSummaryItems(this)

    // Find the summary item by identifier and present the value
    const summaryItem = document.getElementById(this.identifierValue)
    if (summaryItem) {
      this.presentSummaryItemNumber(summaryItem, this.valueValue)
    }

    // Remove the element after updating the summary item
    this.element.remove()
  }
}
